import { useRef, useState } from "react";
import { BtnScanQRWidgetStyled } from "./styled";
import { Icons, Inputs, Modals } from "components";
import { useTranslation } from "react-i18next";

// label: ถ้าไม่ส่งมาจะใช้ข้อความเดิม "แสกนสินค้าเพิ่ม" ซึ่งเขียนไว้สำหรับหน้าประกันสินค้า
// หน้าอื่นที่ไม่ได้สแกนสินค้า (เช่น กิจกรรม) ให้ส่ง label มาเอง
const BtnScanQRWidget = ({ onScanSuccess, label }) => {
  const { i18n } = useTranslation(["home"]);

  const [_isShowModal, _setIsShowModal] = useState(false);
  // Scanner ยิง onScan ทุกเฟรมที่ยังเห็น qrcode ในกล้อง
  // การปิด modal เป็น setState (async) จึงกันไม่ทัน ต้องกันด้วย ref
  // ไม่งั้นยิง API ซ้ำหลายรอบ รอบแรกสำเร็จ รอบถัดไปเด้ง "สแกนไปแล้ว"
  const _isHandledRef = useRef(false);

  const _handleClickScan = async () => {
    // QRScannerView เลือกวิธีสแกนตามความสามารถของ browser เอง
    // ไม่ต้องไล่ลูกค้าออกไปเบราว์เซอร์ข้างนอกอีกแล้ว
    _isHandledRef.current = false;
    _setIsShowModal(true);
  };

  const _handleCloseModal = () => {
    _setIsShowModal(false);
  };

  // TEST
  // const [_value, _setValue] = useState();
  // const _handleChangeValue = (e) => {
  //   _setValue(e.target.value);
  // };

  const _successScan = (detectedCodes) => {
    if (_isHandledRef.current) return;
    if (detectedCodes && detectedCodes.length > 0) {
      _isHandledRef.current = true;
      onScanSuccess && onScanSuccess(detectedCodes[0].rawValue);
      _handleCloseModal();
    }
  };

  return (
    <BtnScanQRWidgetStyled>
      <button className="btn_scan" onClick={_handleClickScan}>
        {label ||
          (i18n.language === "en"
            ? "Turn on the camera to Scan more products"
            : "เปิดกล้องเพื่อ แสกนสินค้าเพิ่ม")}
        <Icons.Scan width={30.22} height={23.8} />
      </button>
      <Modals.BodyEmpty
        isShowModal={_isShowModal}
        onCloseModal={_handleCloseModal}
      >
        <Inputs.QRScannerView
          onScan={_successScan}
          onClose={_handleCloseModal}
        />
        {/* <button
            onClick={() =>
              _successScan({
                text: "https://siammusicmembers.com/product-warrantee/IKX170503-ZR08340",
              })
            }
          >
            Test
          </button> */}
      </Modals.BodyEmpty>
    </BtnScanQRWidgetStyled>
  );
};

export default BtnScanQRWidget;
